/**
 * SalesMailer
 * SalesMailer
 *
 * OpenAPI spec version: n/a
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/';

import { AccountDetails } from '../model/accountDetails';
import { ChangePassword } from '../model/changePassword';
import { CreatePassword } from '../model/createPassword';
import { EditProfile } from '../model/editProfile';
import { PasswordReset } from '../model/passwordReset';
import { PasswordResetStart } from '../model/passwordResetStart';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AccountService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Zmiana hasła przez użytkownika
     *  - __InputParser__: serializer - __UpdateMethodName__: update - __Path__: /profile/{id}/password/change - __InputModelName__: ChangePassword - __OperationName__: Handler - __OperationId__: ChangePasswordHandler - __Name__:  - __Method__: PUT - __Description__:  - __Summary__: Zmiana hasła przez użytkownika - __RouteName__: PUTAccountDetailsHandler - __Hash__: 9cde0c71c78ec541768c3920a0399612 - __Input__: SalesMailer\\Application\\Account\\ChangePassword - __Output__: SalesMailer\\Domain\\Account - __InputGroups__:  - __OutputGroups__: details - __OutputModelName__: AccountDetails - __OutputType__:  - __OutputFileType__:  
     * @param id ID
     * @param content 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public changePasswordHandler(id: string, content?: ChangePassword, observe?: 'body', reportProgress?: boolean): Observable<AccountDetails>;
    public changePasswordHandler(id: string, content?: ChangePassword, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AccountDetails>>;
    public changePasswordHandler(id: string, content?: ChangePassword, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AccountDetails>>;
    public changePasswordHandler(id: string, content?: ChangePassword, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling changePasswordHandler.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<AccountDetails>(`${this.basePath}/api/profile/${encodeURIComponent(String(id))}/password/change`,
            content,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Ustawienie hasła użytkownika po utworzeniu konta
     *  - __InputModelName__: CreatePassword - __InputParser__: serializer - __OperationName__: Handler - __OperationId__: CreatePasswordHandler - __Name__:  - __Path__: /register/password - __Method__: POST - __Description__:  - __Summary__: Ustawienie hasła użytkownika po utworzeniu konta - __RouteName__: POSTAccountDetailsHandler - __Hash__: 5cc4c4ee65a67099b8be55bbb1fedee8 - __Input__: SalesMailer\\Application\\Account\\CreatePassword - __Output__: SalesMailer\\Domain\\Account - __InputGroups__:  - __OutputGroups__: details - __OutputModelName__: AccountDetails - __OutputType__:  - __OutputFileType__:  
     * @param content 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createPasswordHandler(content?: CreatePassword, observe?: 'body', reportProgress?: boolean): Observable<AccountDetails>;
    public createPasswordHandler(content?: CreatePassword, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AccountDetails>>;
    public createPasswordHandler(content?: CreatePassword, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AccountDetails>>;
    public createPasswordHandler(content?: CreatePassword, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<AccountDetails>(`${this.basePath}/api/register/password`,
            content,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     *  - __InputParser__: method - __UpdateMethodName__: updateSelf - __Path__: /profile - __InputModelName__: EditProfile - __OperationName__: Handler - __OperationId__: EditProfileHandler - __Name__:  - __Method__: PUT - __Description__:  - __Summary__:  - __RouteName__: PUTAccountDetailsHandler - __Hash__: 0b616ebc5730a6899092b1d42aa27fac - __Input__: SalesMailer\\Domain\\Account - __Output__: SalesMailer\\Domain\\Account - __InputGroups__:  - __OutputGroups__: details - __OutputModelName__: AccountDetails - __OutputType__:  - __OutputFileType__:  
     * @param content 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editProfileHandler(content?: EditProfile, observe?: 'body', reportProgress?: boolean): Observable<AccountDetails>;
    public editProfileHandler(content?: EditProfile, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AccountDetails>>;
    public editProfileHandler(content?: EditProfile, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AccountDetails>>;
    public editProfileHandler(content?: EditProfile, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<AccountDetails>(`${this.basePath}/api/profile`,
            content,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Ustawienie nowego hasła dla konta na podstawie tokena
     *  - __Path__: /password/reset - __TokenExpiredMethodName__: isPasswordResetTokenExpired - __OperationName__: Handler - __OperationId__: PasswordResetHandler - __Name__:  - __Method__: PUT - __Description__:  - __Summary__: Ustawienie nowego hasła dla konta na podstawie tokena - __RouteName__: PUTHandler - __Hash__: c1f3a22dc25e880a6fb5888ea2614c80 - __Input__: NomaSolutions\\API\\Model\\PasswordReset - __Output__:  - __InputGroups__:  - __OutputGroups__:  - __OutputModelName__:  - __InputModelName__: PasswordReset - __OutputType__:  - __OutputFileType__:  
     * @param content 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public passwordResetHandler(content?: PasswordReset, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public passwordResetHandler(content?: PasswordReset, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public passwordResetHandler(content?: PasswordReset, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public passwordResetHandler(content?: PasswordReset, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/api/password/reset`,
            content,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Uruchomienie procedury resetowania hasła (zapomniałem hasła)
     *  - __Path__: /password/reset/start - __GenerateTokenMethod__: generatePasswordResetToken - __MailerTemplateSystemName__: reset_user_account_password - __OperationName__: Handler - __OperationId__: PasswordResetStartHandler - __Name__:  - __Method__: POST - __Description__:  - __Summary__: Uruchomienie procedury resetowania hasła (zapomniałem hasła) - __RouteName__: POSTHandler - __Hash__: ac9e0de19ed0bb05bbd852260301ddec - __Input__: NomaSolutions\\API\\Model\\PasswordResetStart - __Output__:  - __InputGroups__:  - __OutputGroups__:  - __OutputModelName__:  - __InputModelName__: PasswordResetStart - __OutputType__:  - __OutputFileType__:  
     * @param content 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public passwordResetStartHandler(content?: PasswordResetStart, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public passwordResetStartHandler(content?: PasswordResetStart, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public passwordResetStartHandler(content?: PasswordResetStart, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public passwordResetStartHandler(content?: PasswordResetStart, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/api/password/reset/start`,
            content,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
